import { render, staticRenderFns } from "./developerXeroQueryDialog.vue?vue&type=template&id=c45d0516&scoped=true&"
import script from "./developerXeroQueryDialog.vue?vue&type=script&lang=js&"
export * from "./developerXeroQueryDialog.vue?vue&type=script&lang=js&"
import style0 from "./developerXeroQueryDialog.vue?vue&type=style&index=0&id=c45d0516&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c45d0516",
  null
  
)

export default component.exports